import { Card } from "../components/Card";

const blurbs: Record<string, string> = {
  Overview:
    "Overview KPIs and the 14-day response chart arrive in Phase B, once the underlying SLA data is captured.",
  Alerts:
    "Alerts land in Phase B — you'll see severity, channel, and status here alongside filter pills.",
};

export default function ComingSoon({ screen }: { screen: string }) {
  const blurb = blurbs[screen] ?? "Coming in a later phase.";
  return (
    <Card className="max-w-[560px] mx-auto text-center py-12">
      <div className="mx-auto mb-4 w-10 h-10 rounded-full bg-accent-soft grid place-items-center">
        <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
          <path d="M8 1v3M8 12v3M1 8h3M12 8h3M3 3l2 2M11 11l2 2M3 13l2-2M11 5l2-2"
            stroke="#1F8A6B" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      </div>
      <h2 className="font-display text-[27px] font-semibold">{screen}</h2>
      <p className="mt-3 text-sm text-text-secondary max-w-[380px] mx-auto">
        {blurb}
      </p>
    </Card>
  );
}
